import { render } from "./JobElementWrapper.vue?vue&type=template&id=8bcc0d5e&scoped=true&ts=true"
import script from "./JobElementWrapper.vue?vue&type=script&lang=ts"
export * from "./JobElementWrapper.vue?vue&type=script&lang=ts"

import "./JobElementWrapper.vue?vue&type=style&index=0&id=8bcc0d5e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bcc0d5e"]])

export default __exports__